import { Toaster as Sonner } from 'sonner';

import { useTheme } from './ThemeProvider';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        unstyled: true,
        duration: 100000,
        classNames: {
          toast:
            'group flex flex-row gap-1 justify-start items-center toast group-[.toaster]:text-muted-foreground bg-background rounded-2xl shadow-lg border-0 p-4 w-82 text-sm',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          closeButton: 'absolute -right-1 -top-1 p-1 rounded-full cursor-pointer',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
